const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const track = (type, meta = {}) => {
  try {
    fetch(`${API}/analytics/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ type, meta }),
      keepalive: true,
    });
  } catch {
    // analytics must never break the page
  }
};
